<div
  *ngIf="reader"
  style="
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
  "
>
  <div class="library-info" style="display: flex">
    <div
      class="logo"
      style="width: 2.1cm; height: 2cm; margin-right: 0.35cm"
      *ngIf="HasLogo"
    >
      <img [src]="LogoHref" style="object-fit: contain; width: 100%" />
    </div>
    <div class="school">
      <h1>{{ label }}</h1>
      <h2>Bibliotheksausweis</h2>
    </div>
  </div>

  <div style="display: flex; justify-content: space-between">
    <div class="id">
      <div style="font-size: 0.8rem">
        {{ reader.name }} {{ reader.forename }}, {{ reader.id }}
      </div>
      <svg #barcode></svg>
    </div>

    <div class="schulio" style="margin-top: auto; font-size: 1.3rem">
      <img
        src="https://www.school.schulio.at/assets/img/schulio.png"
        style="
          width: 0.9cm;
          top: 0.25rem;
          position: relative;
          margin-right: 0.25rem;
        "
      />
      Schulio
    </div>
  </div>
</div>
